import React from 'react';

const FeatherLight = ({label, content}) => {
  const handleClick = event => {
    event.preventDefault();
    global.jQuery.featherlight(content, {type: 'html'});
  };

  return (
    <>
      <a
        href='/'
        type='button'
        onClick={handleClick}
        style={{textDecoration: 'underline'}}
      >
        {label}
      </a>
    </>
  );
};

export default FeatherLight;
